<script>
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import permissionChecker from './permissionChecker'
import { watchEffect } from 'vue'
import { Loader } from 'dmui_components'
/**
  Authorization Guard Component to check the authorization for each page
  It encapsulates the router view in App.vue
 */
export default {
	name: 'AuthorizationGuard',
	components: { Loader },
	setup() {
		const { hasPermission, permissionsLoaded } = permissionChecker()
		const route = useRoute()
		const permission = ref(null)
		const hasAccess = ref(false)
		watchEffect(() => {
			/**
			 * Found this as the Only way to get the default props from outside (Props that we set in router.js file) from route
			 */
			let routeProps = route?.matched?.[0]?.props?.default
			if (routeProps instanceof Function) {
				routeProps = routeProps(route)
			}
			permission.value = routeProps?.permission
			if (permission.value) {
				if (permissionsLoaded.value) {
					// Need to pass access on route level
					hasAccess.value = hasPermission(permission.value?.[0], permission.value?.[1])
				}
			} else {
				hasAccess.value = true
			}
		})

		return {
			hasAccess,
			permissionsLoaded
		}
	}
}
</script>
<template>
	<Loader v-if="!permissionsLoaded" />
	<div v-else-if="hasAccess">
		<slot>Please add your application requiring authorization here</slot>
	</div>
	<div v-else class="primary-text">
		<p>You don't have access to this page</p>
		<p>If order to the access, please contact the administrator</p>
	</div>
</template>
